import { render, staticRenderFns } from "./AddVpcOffering.vue?vue&type=template&id=1a2b4b3e&scoped=true&"
import script from "./AddVpcOffering.vue?vue&type=script&lang=js&"
export * from "./AddVpcOffering.vue?vue&type=script&lang=js&"
import style0 from "./AddVpcOffering.vue?vue&type=style&index=0&id=1a2b4b3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b4b3e",
  null
  
)

export default component.exports